import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { DATA_ACCESS_CUSTOMER_DETAILS_FEATURE_KEY, reducers } from './reducers';
import { CustomerStoreEffects } from './effects/customer-store.effects';
import { VerificationEffects } from './effects';

@NgModule({
  imports: [
    StoreModule.forFeature(DATA_ACCESS_CUSTOMER_DETAILS_FEATURE_KEY, reducers),
    EffectsModule.forFeature([CustomerStoreEffects, VerificationEffects]),
  ],
})
export class CustomerStoreModule {}
